import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { getTranslations } from '@translations';
import { Icon } from '@components';

import styles from './styles/index.module.scss';

const Contact = ({ isB2B, className }) => {
  const translations = getTranslations();

  return isB2B ? (
    <div className={cn(styles.container, className)}>
      <p className={styles.paragraph}>
        {translations('header.subheader.contact.b2b.paragraph')}
      </p>
      <a
        href={translations('header.subheader.contact.b2b.tel.link')}
        className={styles.contact}
      >
        <Icon
          id="phone"
          size="18"
          fill="#ffb950"
          className={styles.telephone}
        />
        {translations('header.subheader.contact.b2b.tel.number')}
      </a>
    </div>
  ) : null;
};

Contact.propTypes = {
  isB2B: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

Contact.defaultProps = {
  className: null,
};

Contact.displayName = 'Contact';

export default Contact;
